"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _action = require("../../notification/action");

var _constants = require("../../page-header/constants");

var _actions = require("../../policy/Members/actions");

var _action2 = require("../../spinner-overlay/action");

var _action3 = require("../../../packages/policy-management/modules/permissions/add/action");

var _actions2 = require("./actions");

var _AddPolicy = _interopRequireDefault(require("./AddPolicy"));

var _constants2 = require("./constants");

var _commonConstants = require("../../../utils/common-constants");

var _actions3 = require("../../policy/consumer/actions");

var _actions4 = require("../../policy/notificationMedium/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  var _consumersList$result;

  var addPolicyReducer = state.policyReducer.add;
  var membersReducer = state.membersReducer;
  var _addPolicyReducer$add = addPolicyReducer.addPolicy,
      addPolicyErrors = _addPolicyReducer$add.error,
      addPolicyStatus = _addPolicyReducer$add.status;
  var _membersReducer$users = membersReducer.users,
      usersData = _membersReducer$users.data,
      usersDataStatus = _membersReducer$users.status;
  var _membersReducer$group = membersReducer.groups,
      groupsData = _membersReducer$group.data,
      groupsDataStatus = _membersReducer$group.status;
  var _membersReducer$servi = membersReducer.serviceIdentities,
      serviceIdentitiesData = _membersReducer$servi.data,
      serviceIdentitiesDataStatus = _membersReducer$servi.status;
  var _membersReducer$token = membersReducer.tokens,
      tokensData = _membersReducer$token.data,
      tokensDataStatus = _membersReducer$token.status;
  var consumersList = state.consumerReducer.data;
  var _state$policyReducer$ = state.policyReducer.validateChannelsReducer,
      validateChannelListStatus = _state$policyReducer$.status,
      validateChannelListError = _state$policyReducer$.error;
  return {
    usersData: ((usersData === null || usersData === void 0 ? void 0 : usersData.result) || []).filter(function (user) {
      return user.status.toLowerCase() === _commonConstants.active;
    }),
    usersDataStatus: usersDataStatus,
    groupsData: ((groupsData === null || groupsData === void 0 ? void 0 : groupsData.result) || []).filter(function (tag) {
      return tag.status.toLowerCase() === _commonConstants.active;
    }),
    groupsDataStatus: groupsDataStatus,
    serviceIdentitiesData: ((serviceIdentitiesData === null || serviceIdentitiesData === void 0 ? void 0 : serviceIdentitiesData.result) || []).filter(function (si) {
      return si.status.toLowerCase() === _commonConstants.active;
    }),
    serviceIdentitiesDataStatus: serviceIdentitiesDataStatus,
    tokensData: ((tokensData === null || tokensData === void 0 ? void 0 : tokensData.result) || []).filter(function (token) {
      return token.status.toLowerCase() === _commonConstants.active;
    }),
    tokensDataStatus: tokensDataStatus,
    consumersList: (_consumersList$result = consumersList.result) === null || _consumersList$result === void 0 ? void 0 : _consumersList$result.filter(function (consumer) {
      return consumer.name !== _commonConstants.smConsumer;
    }),
    addPolicyErrors: addPolicyErrors,
    addPolicyStatus: addPolicyStatus,
    validateChannelListStatus: validateChannelListStatus,
    validateChannelListError: validateChannelListError
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    resetActionsData: function resetActionsData() {
      return dispatch({
        type: _constants2.PermissionActionsType.PERMISSION_ACTIONS_RESET
      });
    },
    setPageHeader: function setPageHeader(title, routeToNameList) {
      return dispatch({
        type: _constants.HeaderConstants.HEADER_PROPS,
        payload: {
          title: title,
          routeToNameList: routeToNameList
        }
      });
    },
    fetchUsers: function fetchUsers() {
      return dispatch((0, _actions.getUsersRequest)());
    },
    fetchGroups: function fetchGroups() {
      return dispatch((0, _actions.getGroupsRequest)());
    },
    fetchServiceIdentities: function fetchServiceIdentities() {
      return dispatch((0, _actions.getServiceIdentitiesRequest)());
    },
    fetchTokens: function fetchTokens() {
      return dispatch((0, _actions.getTokensRequest)());
    },
    fetchConsumersList: function fetchConsumersList() {
      return dispatch((0, _actions3.consumerListRequest)());
    },
    createPolicy: function createPolicy(data, history, consumer, consumerEntityId, redirectPath) {
      dispatch((0, _actions2.createPolicyRequest)(data, history, consumer, consumerEntityId, redirectPath));
    },
    openNotification: function openNotification(type, title, duration) {
      return dispatch((0, _action.openNotification)(type, title, true, duration));
    },
    initSpinnerOverlay: function initSpinnerOverlay(data) {
      return dispatch((0, _action2.initSpinnerOverlay)(data));
    },
    getApplicationsList: function getApplicationsList() {
      return dispatch((0, _action3.requestApplicationList)());
    },
    validateChannelList: function validateChannelList(notificationMediumId, channelList) {
      return dispatch((0, _actions4.validateChannelList)(notificationMediumId, channelList));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_AddPolicy.default);

exports.default = _default;